import React from 'react';
import Footer from '@ajat/design-system/Footer';
import useMenuItemNavigation from '../../../../hooks/useMenuItemNavigation';
import useMenuItemVisibility from '../../../../hooks/useMenuItemVisibility';

/* ══════════════════════════════════════════════════════════════════════════
 * CLS-SE — Common Footer
 * Single source of truth for footer configuration across all CLS-SE pages
 * Navigation column mirrors the Header navItems
 * ══════════════════════════════════════════════════════════════════════════ */

const legalLinks = [
  { label: 'Köpvillkor', href: '/clothing/cls-se/terms' },
  { label: 'Personuppgiftspolicy', href: '/clothing/cls-se/privacy' },
];

const socials = [
  { icon: 'facebook', href: 'https://www.facebook.com/clseifert.se', ariaLabel: 'Facebook' },
  { icon: 'instagram', href: 'https://www.instagram.com/clseifert_sverige/', ariaLabel: 'Instagram' },
];

const contact = {
  title: 'KONTAKTA OSS',
  email: { label: 'info@clseifert.se', href: 'mailto:info@clseifert.se' },
  address: ['Box 24262,', '104 51 Stockholm'],
};

export const copyright = `© ${new Date().getFullYear()} C.L. Seifert Sverige AB, All Rights Reserved`;

const CLSSEFooter = (props) => {
  const onMenuItemClick = useMenuItemNavigation({ brandSlug: 'clsse', feSlug: 'cls-se' });
  const { isVisible } = useMenuItemVisibility('clsse');

  const columns = [
    {
      title: 'BEHÖVER DU HJÄLP?',
      links: [
        { label: 'Kundservice', href: '/clothing/cls-se/faq' },
        { label: 'Storleksguide', href: '/clothing/cls-se/size-guide' },
        { label: 'Kontakta oss', href: '/clothing/cls-se/contact' },
      ],
    },
    {
      title: 'C.L. SEIFERT',
      links: [
        { label: 'Skolmerch', menuKey: 'menu_1', href: '#', onClick: (e) => { e.preventDefault(); onMenuItemClick('menu_1'); } },
        { label: 'Overalls & More', menuKey: 'menu_2', href: '#', onClick: (e) => { e.preventDefault(); onMenuItemClick('menu_2'); } },
        { label: 'Studentmössor', href: 'https://clseifert.com/sv' },
      ],
    },
  ].map((col) => ({
    // Same visibility rule as the header menu items ("Disable Open Shop").
    ...col,
    links: col.links.filter((l) => !l.menuKey || isVisible(l.menuKey)),
  }));

  return (
    <Footer brand="CLS" columns={columns} legalLinks={legalLinks} socials={socials} contact={contact} copyright={copyright} {...props} />
  );
};

export default CLSSEFooter;
